var _defs, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDissatisfiedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 95,
    height: 40,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#0d0d0d;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M114.437,224a13.651,13.651,0,0,0-10.169,4.521,1.043,1.043,0,1,0,1.555,1.392,11.609,11.609,0,0,1,17.228,0,1.043,1.043,0,1,0,1.555-1.392A13.651,13.651,0,0,0,114.437,224Z",
    transform: "translate(-90.437 -194.783)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M24,0A24,24,0,1,0,48,24,24.028,24.028,0,0,0,24,0Zm0,45.913A21.913,21.913,0,1,1,45.913,24,21.937,21.937,0,0,1,24,45.913Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M90.429,117.213a1.045,1.045,0,0,0-.577-.934L81.5,112.1a1.044,1.044,0,0,0-.934,1.867l6.482,3.241-6.481,3.24a1.044,1.044,0,0,0,.933,1.868l8.348-4.174A1.045,1.045,0,0,0,90.429,117.213Z",
    transform: "translate(-69.559 -97.387)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M217.859,120.458l-6.482-3.24,6.481-3.24a1.043,1.043,0,1,0-.933-1.867l-8.348,4.174a1.043,1.043,0,0,0,0,1.867l8.348,4.174a1.044,1.044,0,0,0,.934-1.868Z",
    transform: "translate(-180.87 -97.392)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDissatisfiedIcon);
export default __webpack_public_path__ + "static/media/dissatisfied-icon.0d02e8fff0bdaee8761da6b5ef477600.svg";
export { ForwardRef as ReactComponent };